import { filterFieldsType } from '../../../../../state/ducks/allShipmentsPage/allShipmentsPage';

export const defaultConsolidationFilters: filterFieldsType = [];

export const normalizeConsolidationFilters = (filter: filterFieldsType): filterFieldsType => {
    return [...filter];
};
